"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AskQuestionOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M23 17V5a3 3 0 00-3-3H5a3 3 0 00-3 3v12a3 3 0 003 3h2v6a1 1 0 00.61.92A1.09 1.09 0 008 27a1 1 0 00.7-.29L15.41 20H20a3 3 0 003-3zm-8.71 1.29L9 23.59V20a2 2 0 00-2-2H5a1 1 0 01-1-1V5a1 1 0 011-1h15a1 1 0 011 1v12a1 1 0 01-1 1h-5a1 1 0 00-.71.29z"/><path d="M15.15 9.08c0-1.26-1.07-2.14-2.67-2.14A2.54 2.54 0 009.9 8.5a1.58 1.58 0 00-.05.38.62.62 0 00.7.67.69.69 0 00.72-.47 1.09 1.09 0 011.11-.83.94.94 0 011.06.88c0 .51-.22.78-.94 1.2a1.69 1.69 0 00-1 1.57v.1a.67.67 0 00.76.67.67.67 0 00.75-.57c0-.47.26-.71 1-1.12a2 2 0 001.14-1.9zM12.27 13.31a.89.89 0 10.92.88.89.89 0 00-.92-.88zM23.1 22.43a.56.56 0 010-.12.56.56 0 000 .12z"/><path d="M27 5h-1a1 1 0 000 2h1a1 1 0 011 1v11.57A1.43 1.43 0 0126.57 21H25a1.81 1.81 0 00-.4 0l-.17.05-.2.06-.24.13h-.09a2.15 2.15 0 00-.28.23 2.17 2.17 0 00-.24.29 2.35 2.35 0 00-.22.45.56.56 0 000 .12A1.83 1.83 0 0023 23v3.59l-.73-.72-3.5-3.5a1 1 0 00-1.41 1.42l5.93 5.94a1 1 0 00.33.21.94.94 0 00.76 0 1 1 0 00.54-.54A1 1 0 0025 29v-6h2a3 3 0 003-3V8a3 3 0 00-3-3z"/>';
var AskQuestionOutlineSVG = function AskQuestionOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.AskQuestionOutlineSVG = AskQuestionOutlineSVG;
AskQuestionOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(AskQuestionOutlineSVG);
exports.default = _default;